@if ((serviceConnected$ | async) === true) {
  @if (useAlternateStyling) {
    <ng-content select="integrations-connect-element"></ng-content>
  } @else {
    <va-badge color="green">
      {{ 'FRONTEND.MEETING_INTEGRATIONS.CONNECTION_STATUS_ELEMENT.SERVICE_CONNECTED' | translate }}
    </va-badge>
  }
} @else {
  @if (useAlternateStyling) {
    <ng-content select="integrations-disconnect-element"></ng-content>
  } @else {
    <va-badge color="red">
      {{ 'FRONTEND.MEETING_INTEGRATIONS.CONNECTION_STATUS_ELEMENT.SERVICE_NOT_CONNECTED' | translate }}
    </va-badge>
  }
}






